/** @format */

import { EventOptions } from 'src/pages/EventCenter/constants'
import { mbpsproduct } from 'src/containers/MonitorCreate'
import { _$, Tag } from '@king-design/react'

export interface DateTimeProps {
  StartTime: number
  EndTime: number
}

// 阈值告警历史 && 事件告警历史
export interface TabsListProps {
  className?: string
  region?: string
  dateTime: DateTimeProps
  query: string
  queryType?: 'InstanceId' | 'PolicyName'
  eventProduct?: number
  policyName?: string
  policyId?: string
  eventProductList?: EventOptions[]
}
// 'GreaterThanLastPeriod', 'LessThanLastPeriod'
// 告警策略中获取单位
export const getRulesUnits = (
  rule: string,
  curValue = 0,
  productType?
): { units: string; triggerValue: number } => {
  let units = ''
  let value = curValue
  const ruleSplit = rule.split(' ')
  const methodFind = ruleSplit.findIndex(
    item =>
      item === '>' ||
      item === '<' ||
      item === '=' ||
      item === 'GreaterThanLastPeriod' ||
      item === 'LessThanLastPeriod'
  )
  const frageRule = ruleSplit[methodFind + 1]
  if (frageRule.includes('Gbps')) {
    units = 'Gbps'
  } else if (frageRule.includes('bps')) {
    // 默认单位为Mbps的直接返回Mbps
    if (mbpsproduct.includes(parseInt(productType)) && frageRule.includes('Mbps')) {
      units = 'Mbps'
    } else {
      if (curValue < 1024) {
        units = 'bps'
      } else if (curValue >= 1024 && curValue < 1024 * 1024) {
        const formatValue = curValue / 1024
        units = 'Kbps'
        value = curValue % 1024 === 0 ? formatValue : parseFloat(formatValue.toFixed(3))
      } else if (curValue >= 1024 * 1024) {
        const formatValue = curValue / 1024 / 1024
        units = 'Mbps'
        value = (curValue % 1024) % 1024 === 0 ? formatValue : parseFloat(formatValue.toFixed(3))
      }
    }
  } else if (frageRule.includes('pps')) {
    units = 'pps'
  } else if (frageRule.includes('%')) {
    units = '%'
  } else if (frageRule.includes('个/s')) {
    units = '个/s'
  } else if (frageRule.includes('个/秒')) {
    units = '个/秒'
  } else if (frageRule.includes('个/min')) {
    units = '个/min'
  } else if (frageRule.includes('个')) {
    units = '个'
  } else if (frageRule.includes('millicores')) {
    units = 'millicores'
  } else if (frageRule.includes('msg/min')) {
    units = 'msg/min'
  } else if (frageRule.includes('op/s')) {
    units = 'op/s'
  } else if (frageRule.includes('page/s')) {
    units = 'page/s'
  } else if (frageRule.includes('qps')) {
    units = 'qps'
  } else if (frageRule.includes('条')) {
    units = '条'
  } else if (frageRule.includes('行')) {
    units = '行'
  } else if (frageRule.includes('次/秒')) {
    units = '次/秒'
  } else if (frageRule.includes('次/s')) {
    units = '次/秒'
  } else if (frageRule.includes('次/每秒')) {
    units = '次/秒'
  } else if (frageRule.includes('次')) {
    units = '次'
  } else if (frageRule.includes('kB/s')) {
    units = 'kB/s'
  } else if (frageRule.includes('MB/秒') || frageRule.includes('MB/s')) {
    units = 'MB/s'
  } else if (frageRule.includes('MBytes')) {
    units = 'MBytes'
  } else if (frageRule.includes('cu')) {
    units = 'cu'
  } else if (frageRule.includes('Kb/s')) {
    units = 'Kb/s'
  } else if (frageRule.includes('b/s')) {
    units = 'b/s'
  } else if (frageRule.includes('B/s')) {
    units = 'B/s'
  } else if (frageRule.includes('字节/每秒')) {
    units = '字节/每秒'
  } else if (frageRule.includes('字节/秒')) {
    units = '字节/秒'
  } else if (frageRule.includes('字节')) {
    units = '字节'
  } else if (frageRule.includes('GB')) {
    units = 'GB'
  } else if (frageRule.includes('Ops')) {
    units = 'Ops'
  } else if (frageRule.includes('count')) {
    units = 'count'
  } else if (frageRule.includes('MiB')) {
    units = 'MiB'
  } else if (frageRule.includes('℃')) {
    units = '℃'
  } else if (frageRule.includes('G')) {
    units = 'G'
  } else if (frageRule.includes('Byte/秒')) {
    units = 'Byte/秒'
  } else if (frageRule.includes('毫秒')) {
    units = '毫秒'
  } else if (frageRule.includes('Byte/每秒')) {
    units = 'Byte/每秒'
  } else if (frageRule.includes('秒')) {
    units = '秒'
  } else if (frageRule.includes('bit/s')) {
    units = 'bit/s'
  } else if (frageRule.includes('bytes/s')) {
    units = 'bytes/s'
  } else if (frageRule.includes('Bps')) {
    units = 'Bps'
  } else if (frageRule.includes('S')) {
    units = 'S'
  } else if (frageRule.includes('s')) {
    if (frageRule.includes('us')) {
      units = 'us'
    } else if (frageRule.includes('ms')) {
      units = 'ms'
    } else {
      units = 's'
    }
  } else if (frageRule.includes('核')) {
    units = '核'
  } else if (frageRule.includes('bytes')) {
    units = 'bytes'
  } else if (frageRule.includes('byte')) {
    units = 'byte'
  } else if (frageRule.includes('B/sec')) {
    units = 'B/sec'
  } else if (frageRule.includes('B')) {
    units = 'B'
  } else {
    units = ''
  }
  return { units, triggerValue: value }
}

// 阈值告警历史table联系人弹窗scheme
export const reciverScheme = {
  name: {
    title: _$('名称'),
    width: 120,
    template: item => {
      return (
        <span>
          {item.name} {item.scheduleId !== undefined ? '[值班表]' : ''}
        </span>
      )
    }
  },
  email: {
    title: _$('邮箱'),
    template: item => {
      const { email, notificationResult } = item
      return (
        <div className="ksc-space">
          <span>{email}</span>
          {notificationResult.email ? (
            <Tag type={notificationResult.email.status === 'success' ? 'success' : 'danger'}>
              {notificationResult.email.resason}
            </Tag>
          ) : null}
        </div>
      )
    }
  },
  phone: {
    title: _$('电话'),
    template: item => {
      const { phone, notificationResult } = item
      return phone ? (
        <>
          <div>{phone}</div>
          {notificationResult.phone ? (
            <div className="ksc-space">
              <span>电话</span>
              <Tag type={notificationResult.phone.status === 'success' ? 'success' : 'danger'}>
                {notificationResult.phone.resason}
              </Tag>
            </div>
          ) : null}
          {notificationResult.sms ? (
            <div className="ksc-space">
              <span>短信</span>
              <Tag type={notificationResult.sms.status === 'success' ? 'success' : 'danger'}>
                {notificationResult.sms.resason}
              </Tag>
            </div>
          ) : null}
        </>
      ) : (
        '-'
      )
    }
  }
}

// 阈值告警历史table设置表头
export const tableScheme = [
  {
    label: '策略名称',
    value: 'policyName',
    disabled: true
  },
  {
    label: '产品类型',
    value: 'productType',
    disabled: true
  },
  {
    label: '故障资源',
    value: 'instanceName',
    disabled: true
  },
  {
    label: '告警规则',
    value: 'rule',
    disabled: true
  },
  {
    label: '触发值',
    value: 'curValue'
  },
  {
    label: '发生时间',
    value: 'triggerTime'
  },
  {
    label: '持续时间',
    value: 'duration'
  },
  {
    label: '通知对象',
    value: 'reciver'
  },
  {
    label: '状态',
    value: 'alarmState'
  },
  {
    label: '操作',
    value: 'action',
    disabled: true
  }
]
export const initSchemeValue = [
  'policyName',
  'productType',
  'instanceName',
  'rule',
  'curValue',
  'triggerTime',
  'duration',
  'reciver',
  'alarmState',
  'action'
]
